import getUrl from 'airship/modules/get-url'
import createRequest, {
  TypesafeRequester,
} from 'airship/modules/typesafe-request'
import {
  nullableResolver,
  objectResolver,
  resolveString,
} from 'airship/utils/resolvers'
import {Resolver} from 'airship/utils/resolvers/types'

export const USER_METADATA_URL = 'registration:user_metadata'

export type UserMeta = {
  named_user_id: string | null
  environment: string
}

const userMetaResolver: Resolver<UserMeta> = objectResolver({
  named_user_id: nullableResolver(resolveString),
  environment: resolveString,
})

export interface UserMetaClient {
  get(): Promise<UserMeta>
}

class AirshipUserMetaClient implements UserMetaClient {
  private _requester: TypesafeRequester

  constructor(requester: TypesafeRequester) {
    this._requester = requester
  }

  async get(): Promise<UserMeta> {
    const path = getUrl(USER_METADATA_URL)
    const res = await this._requester.get(userMetaResolver, {path})
    return res.body
  }
}

export default function createDefaultUserMetaClient(): UserMetaClient {
  const requester = createRequest()
  return createUserMetaClient(requester)
}

export function createUserMetaClient(
  requester: TypesafeRequester
): UserMetaClient {
  return new AirshipUserMetaClient(requester)
}
